import { RequestSender } from "./helpers";

async function deleteProfile(request: RequestSender) {
  await request("delete", `/profile/`);
}

export default deleteProfile;
